import { List, ListItem } from 'foundations-components/transitional/components/List';
import FileActions from '../FileActions';
import ResolvedFileItem from '../ResolvedFileItem';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const FileResolvedValuesList = ({
  fileReferences,
  isEditDisabled,
  uploadsInProgress,
  onFileAction
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: fileReferences.map((fileReference, index) => /*#__PURE__*/_jsx(ListItem, {
      "data-test-id": fileReference.id,
      marginBlockEnd: "50",
      children: /*#__PURE__*/_jsx(TFlex, {
        children: /*#__PURE__*/_jsx(ResolvedFileItem, {
          fileReference: fileReference,
          actions: /*#__PURE__*/_jsx(FileActions, {
            fileId: fileReference.id,
            disabled: isEditDisabled,
            index: index,
            totalFiles: fileReferences.length,
            uploadsInProgress: uploadsInProgress,
            onFileAction: onFileAction
          })
        })
      })
    }, fileReference.id))
  });
};
export default FileResolvedValuesList;